import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  containerToDo: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '9px 16px',
    borderRadius: '0.5rem',
    border: '1px solid #EF6C00',
    color: '#EF6C00',
  },

  containerInitialized: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '9px 16px',
    borderRadius: '0.5rem',
    border: '1px solid #3024E1',
    color: '#3024E1',
  },

  containerCompleted: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '9px 16px',
    borderRadius: '0.5rem',
    border: '1px solid #2E7D32',
    color: '#2E7D32',
  },

  textContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1',
  },

  statusCounter: {
    borderRadius: '999px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#3024E1',
    fontFamily: 'Nunito',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '20px',
    width: '21px',
    height: '20px',
    color: '#ffffff',
  },
}))

export { useStyles }
